import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import PageTransition from '../PageTransition';
import ScrollToTopButton from '../ui/scroll-to-top-button';
import BottomNavigation from '../navbar/BottomNavigation';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md"
      >
        Saltar al contenido principal
      </a>
      <Navbar />
      <main id="main-content" className="flex-grow pb-16 md:pb-0">
        <PageTransition>
          {children}
        </PageTransition>
      </main>
      <Footer className="mb-16 md:mb-0" />
      <ScrollToTopButton />
      <BottomNavigation />
    </div>
  );
};

export default MainLayout;
